var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5369 5.67943C11.7657 5.45061 12.1366 5.45061 12.3654 5.67943L16.2717 9.5857C16.5005 9.81453 16.5005 10.1855 16.2717 10.4143L12.3654 14.3205C12.1366 14.5494 11.7657 14.5494 11.5369 14.3205C11.308 14.0917 11.308 13.7208 11.5369 13.492L15.0287 10L11.5369 6.50807C11.308 6.27925 11.308 5.90825 11.5369 5.67943Z",
    fill: "#4C4D52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4428 9.41406H8.04492C7.30012 9.41406 6.19595 9.63266 5.26115 10.3058C4.29647 11.0003 3.55273 12.1528 3.55273 13.9062C3.55273 14.2298 3.81507 14.4922 4.13867 14.4922C4.46227 14.4922 4.72461 14.2298 4.72461 13.9062C4.72461 12.5347 5.28295 11.7341 5.94588 11.2568C6.63869 10.758 7.48764 10.5859 8.04492 10.5859H14.4428L15.0288 10L14.4428 9.41406Z",
    fill: "#4C4D52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3994 9.77539C16.4281 9.84445 16.4439 9.92023 16.4439 9.99969C16.4439 9.92336 16.429 9.84703 16.3994 9.77539Z",
    fill: "#4C4D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.2b98f69550a884579a9fea662822845c.svg";
export { ForwardRef as ReactComponent };